import React from 'react';
import styled from "styled-components";

interface CustomLineProps {
  type: "vertical" | "horizontal";
  size?: number;
}

function CustomLine({ type, size }: CustomLineProps) {
  return <StyledCustomLine className={type} $size={size} />;
}

const StyledCustomLine = styled.div<{ $size?: number }>`
  &.vertical {
    border-bottom: 1px solid #E1E1E7;
    width: ${({ $size }) => (!!$size ? `${$size}px` : "100%")};
  }
  &.horizontal {
    border-right: 1px solid #E1E1E7;
    height: ${({ $size }) => (!!$size ? `${$size}px` : "100%")};
  }
`;

export default CustomLine;
